module.exports = __webpack_public_path__ + "static/media/buildlab.b6cb9f25.svg";